import { createFileRoute, redirect } from "@tanstack/react-router";

import { handleSupabaseAuthCallback } from "@/integrations/auth/supabase";

export const Route = createFileRoute("/auth/supabase/callback")({
  server: {
    handlers: {
      GET: async ({ request }) => {
        const requestUrl = new URL(request.url);
        const result = await handleSupabaseAuthCallback(requestUrl);
        const shouldSetPassword = result.ok && (result.type === "invite" || result.type === "recovery");
        const redirectUrl = new URL(
          result.ok
            ? shouldSetPassword
              ? "/auth/reset-password"
              : result.type === "signup"
                ? "/dashboard/resumes?activation=activated"
                : "/dashboard"
            : "/auth/login",
          requestUrl.origin,
        );

        if (!result.ok) {
          redirectUrl.searchParams.set("error", result.errorDescription ?? result.error);
        } else if (shouldSetPassword) {
          redirectUrl.searchParams.set("mode", result.type);
        }

        return new Response(null, {
          status: 302,
          headers: { Location: redirectUrl.toString() },
        });
      },
    },
  },
  beforeLoad: () => {
    throw redirect({ to: "/dashboard", replace: true });
  },
});
